/* eslint-disable no-case-declarations */

import {
  LOADING_DEVICES,
  LOADING_DEVICES_SUCCESS,
  LOADING_DEVICES_ERROR,

  ADDING_DEVICE,
  ADDING_DEVICE_SUCCESS,
  ADDING_DEVICE_ERROR,

  UPDATING_DEVICE,
  UPDATING_DEVICE_SUCCESS,
  UPDATING_DEVICE_ERROR,

  DELETING_DEVICE,
  DELETING_DEVICE_SUCCESS,
  DELETING_DEVICE_ERROR,

  FINDING_DEVICES,
  FINDING_DEVICES_SUCCESS,
  FINDING_DEVICES_ERROR,

  FINDING_DEVICE_LOGS,
  FINDING_DEVICE_LOGS_SUCCESS,
  FINDING_DEVICE_LOGS_ERROR,

  DELETING_DEVICE_LOGS,
  DELETING_DEVICE_LOGS_SUCCESS,
  DELETING_DEVICE_LOGS_ERROR,

  FINDING_DEVICE_ERRORS,
  FINDING_DEVICE_ERRORS_SUCCESS,
  FINDING_DEVICE_ERRORS_ERROR,

  DELETING_DEVICE_ERRORS,
  DELETING_DEVICE_ERRORS_SUCCESS,
  DELETING_DEVICE_ERRORS_ERROR,

  FINDING_DEVICE_HISTORIES,
  FINDING_DEVICE_HISTORIES_SUCCESS,
  FINDING_DEVICE_HISTORIES_ERROR,

  DELETING_DEVICE_HISTORIES,
  DELETING_DEVICE_HISTORIES_SUCCESS,
  DELETING_DEVICE_HISTORIES_ERROR,

  LOADING_MODEMS,
  LOADING_MODEMS_SUCCESS,
  LOADING_MODEMS_ERROR,

  ADDING_MODEM,
  ADDING_MODEM_SUCCESS,
  ADDING_MODEM_ERROR,

  UPDATING_MODEM,
  UPDATING_MODEM_SUCCESS,
  UPDATING_MODEM_ERROR,

  DELETING_MODEM,
  DELETING_MODEM_SUCCESS,
  DELETING_MODEM_ERROR,

  FINDING_MODEMS,
  FINDING_MODEMS_SUCCESS,
  FINDING_MODEMS_ERROR,

  FINDING_MODEM_HISTORIES,
  FINDING_MODEM_HISTORIES_SUCCESS,
  FINDING_MODEM_HISTORIES_ERROR,

  DELETING_MODEM_HISTORIES,
  DELETING_MODEM_HISTORIES_SUCCESS,
  DELETING_MODEM_HISTORIES_ERROR,

} from '../actions/devices';

const initialState = {
  reged_deviceList: [],
  deviceList: [],
  deviceLogList: [],
  deviceErrorList: [],
  deviceHistoryList: [],
  modemList: [],
  modemHistoryList: [],
  device_total: 0,
  loading: false,
  find_device_loading: false,
};
  
const CompaniesReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_DEVICES:
        return { ...state, loading: true };
  
      case LOADING_DEVICES_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          reged_deviceList: action.payload,
        };

      case ADDING_DEVICE:
        return { ...state, loading: true };
  
      case ADDING_DEVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          //deviceList: [...state.deviceList, action.payload],
          deviceList: [action.payload],
          device_total: 1,
        };

      case UPDATING_DEVICE:
        return { ...state, loading: true };
  
      case UPDATING_DEVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          deviceList: [...state.deviceList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_DEVICE:
        return { ...state, loading: true };
  
      case DELETING_DEVICE_SUCCESS:
        return {
          ...state,
          loading: false,
          deviceList: [...state.deviceList.filter((obj) => {
            const findObj = action.payload.find(removedDevice => (removedDevice.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case FINDING_DEVICES:
        return { ...state, find_device_loading: true };
  
      case FINDING_DEVICES_SUCCESS:
        return {
          ...state,
          find_device_loading: false,
          device_total: action.payload.find_total,
          deviceList: action.payload.find_devices,
        };

      case FINDING_DEVICE_LOGS:
        return { ...state, find_device_loading: true };
  
      case FINDING_DEVICE_LOGS_SUCCESS:
        return {
          ...state,
          find_device_loading: false,
          device_total: action.payload.find_total,
          deviceLogList: action.payload.find_logs,
        };

      case DELETING_DEVICE_LOGS:
        return { ...state, loading: true };
  
      case DELETING_DEVICE_LOGS_SUCCESS:
        return {
          ...state,
          loading: false,
          deviceLogList: action.payload,
        };
  
      case FINDING_DEVICE_ERRORS:
        return { ...state, find_device_loading: true };
  
      case FINDING_DEVICE_ERRORS_SUCCESS:
        return {
          ...state,
          find_device_loading: false,
          device_total: action.payload.find_total,
          deviceErrorList: action.payload.find_errors,
        };

      case DELETING_DEVICE_ERRORS:
        return { ...state, loading: true };
  
      case DELETING_DEVICE_ERRORS_SUCCESS:
        return {
          ...state,
          loading: false,
          deviceErrorList: action.payload,
        };

      case FINDING_DEVICE_HISTORIES:
        return { ...state, find_device_loading: true };
  
      case FINDING_DEVICE_HISTORIES_SUCCESS:
        return {
          ...state,
          find_device_loading: false,
          device_total: action.payload.find_total,
          deviceHistoryList: action.payload.find_histories,
        };

      case DELETING_DEVICE_HISTORIES:
        return { ...state, loading: true };

      case DELETING_DEVICE_HISTORIES_SUCCESS:
        return {
          ...state,
          loading: false,
          deviceHistoryList: action.payload,
        };

      

      case LOADING_MODEMS:
        return { ...state, loading: true };
  
      case LOADING_MODEMS_SUCCESS:
        //console.log(action.payload);
        return {
          ...state,
          loading: false,
          modemList: action.payload,
        };
  
      case ADDING_MODEM:
        return { ...state, loading: true };
  
      case ADDING_MODEM_SUCCESS:
        return {
          ...state,
          loading: false,
          modemList: [...state.modemList, action.payload],
        };

      case UPDATING_MODEM:
        return { ...state, loading: true };
  
      case UPDATING_MODEM_SUCCESS:
        return {
          ...state,
          loading: false,
          modemList: [...state.modemList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_MODEM:
        return { ...state, loading: true };
  
      case DELETING_MODEM_SUCCESS:
        return {
          ...state,
          loading: false,
          modemList: [...state.modemList.filter((obj) => {
            const findObj = action.payload.find(removedModem => (removedModem.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case FINDING_MODEMS:
        return { ...state, find_device_loading: true };
  
      case FINDING_MODEMS_SUCCESS:
        return {
          ...state,
          find_device_loading: false,
          device_total: action.payload.find_total,
          modemList: action.payload.find_modems,
        };

      case FINDING_MODEM_HISTORIES:
        return { ...state, find_device_loading: true };
  
      case FINDING_MODEM_HISTORIES_SUCCESS:
        return {
          ...state,
          find_device_loading: false,
          device_total: action.payload.find_total,
          modemHistoryList: action.payload.find_mhistories,
        };

      case DELETING_MODEM_HISTORIES:
        return { ...state, loading: true };

      case DELETING_MODEM_HISTORIES_SUCCESS:
        return {
          ...state,
          loading: false,
          modemHistoryList: action.payload,
        };

      default:
        return state;
    }
  };
  
  export default CompaniesReducer;
  